<div class="bg-white rounded-4 mb-3 position-relative div-shadow" *ngIf="!loading">
  <div *ngIf="paseo?.foto_cabecera_grande" class="image-container pointer" [ngStyle]="{'background-image': 'url(' + paseo?.foto_cabecera_grande + ')'}"></div>
  <div class="p-3">
    <!-- Paseo -->
    <div class="mb-2 fw-bold fs-4 text-iguau">{{paseo.pa_titulo}}</div>
    <!-- Descripción -->
    <div class="mb-3">
      <div [innerHTML]="paseo.pa_descripcion"></div>
    </div>
    <!-- Detalles -->
    <div class="row">
      <div class="col">
        <div class="fw-bold mb-2 text-iguau">{{paseo.participantes.length}} {{paseo.participantes.length == 1 ? 'participante' : 'participantes'}}</div>
        <div class="mb-4 border rounded p-2" *ngIf="paseo.participantes.length > 0">
          <div class="row align-items-center">
            <div class="col-auto align-items-top position-relative" *ngFor="let participante of paseo.participantes">
              <div class="d-flex w-100 align-content-center justify-content-center pointer" (click)="funciones.goPerfil(participante.slug)">
                <div class="me-2">
                  <div class="imagenes-montadas imagenes-montadas-mas">
                    <img
                      *ngIf="participante.foto_principal_thumb"
                      [src]="participante.foto_principal_thumb || global.urlServer + 'img/default-user.png'"
                      class="rounded-circle pointer"
                      width="40"
                      [style.zIndex]="100">
                    <img *ngFor="let mascota of participante.mascotas; let i = index"
                      [src]="mascota.foto.foto_thumb"
                      class="rounded-circle pointer"
                      width="40px"
                      [style.zIndex]="participante.mascotas.length - i">
                  </div>
                </div>
                <div>
                  {{participante.first_name | firstWord}}
                  <div class="text-secondary small">
                    <span *ngIf="participante.sexo=='Hombre'"><i class="fa-solid fa-mars"></i></span>
                    <span *ngIf="participante.sexo=='Mujer'"><i class="fa-solid fa-venus"></i></span>
                    {{participante.sexo}} de {{participante.edad}}
                    <div>
                    <span *ngIf="participante.barrio">{{participante.barrio}}</span>
                    <span *ngIf="participante.ciudad"><span *ngIf="participante.barrio" class="me-1">,</span>{{participante.ciudad}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col" *ngIf="misdatos.ID != paseo.pa_us_id && !paseo.pasado">
            <span *ngIf="busy > 0" class="spinner-border spinner-border-sm me-1 text-iguau" aria-hidden="true"></span>
            <i *ngIf="busy == 0" class="fa-solid fa-person-walking me-1"></i>
            <span *ngIf="paseo.participante">Ya participas en este paseo, </span>
            <span *ngIf="!paseo.participante">No participas en este paseo, </span>
            <a class="pointer custom-link" (click)="participar()">
              <span *ngIf="!paseo.participante">quiero participar</span>
              <span *ngIf="paseo.participante">ya no quiero participar</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="bg-white rounded-4 mb-3 p-3 text-iguau div-shadow">
    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    Paseo... 
  </div>
</div>